// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"388":"24a913c8","529":"e92af610"}[chunkId] + ".js";
};